import { Loading, decryptData, formatMoney } from "../components/const";
import { useEffect, useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import ContextMenuFacture from "./ContextMenuFacture";
import $ from "jquery";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const FactureNonPayees = ({ idmagasin }) => {
    const profile = decryptData("user_profile");
    if (!idmagasin) {
        idmagasin = profile.idmagasin;
    }

    const tableRef = useRef(null);
    let { data: factures, isloading } = UseFetch(`ventes/factures/${idmagasin}`);
    factures?.sort((a, b) => a.idfacture - b.idfacture);
    $(tableRef.current).DataTable();

    const totalMontant = factures?.reduce(
        (previousValue, current) => previousValue + +current.montant,
        0
    );
    const totalPaye = factures?.reduce(
        (previousValue, current) => previousValue + +current.paye,
        0
    );
    const totalDette = factures?.reduce(
        (previousValue, current) => previousValue + +current.reste,
        0
    );

    // 📌 Fonction pour imprimer la liste en PDF
    const printFactures = () => {
        const doc = new jsPDF("p", "pt"); // portrait, points

        // Titre
        doc.setFontSize(14);
        doc.text("Liste des Factures Impayées", 40, 40);

        // Génération tableau avec autotable
        autoTable(doc, {
            startY: 60,
            head: [
                [
                    "N°FACTURE",
                    "CLIENT",
                    "TELEPHONE",
                    "ADRESSE",
                    "MONTANT",
                    "PAYE",
                    "RESTE",
                    "VENDEUR",
                    "DATE",
                ],
            ],
            body: factures.map((fact) => [
                fact.numero,
                fact.client,
                fact.telephone,
                fact.adresse,
                (fact.montant),
                (fact.paye),
                (fact.reste),
                (fact.vendeur || "").toUpperCase(),
                fact.created_at,
            ]),
            styles: { fontSize: 8 },
            theme: "striped",
            headStyles: { fillColor: [41, 128, 185] },
        });
        // Position Y après le tableau
        let finalY = doc.lastAutoTable.finalY + 20;

        // Totaux
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(
            `Total Montant : ${((totalMontant) || 0)} GNF`,
            40,
            finalY
        );
        doc.text(
            `Total Payé : ${totalPaye || 0} GNF`,
            40,
            finalY + 20
        );
        doc.text(
            `Total Impayé : ${totalDette || 0} GNF`,
            40,
            finalY + 40
        );

        // Sauvegarde
        doc.save(`factures_impayees_${idmagasin}.pdf`);
    };

    return isloading ? (
        <Loading />
    ) : factures?.length ? (
        <div className="row">
            <div className="row p-2 justify-content-between align-items-center">
                <div className="col-lg-4 text-primary h3">Factures impayées</div>
                <div className="table-responsive">
                    <div className="row p-1 justify-content-center align-items-center row-cols-1 row-cols-md-4">
                        <div className="col-texte-center card m-1">
                            Total Montant:{" "}
                            <span className="text-primary fw-bold">
                                {totalMontant?.toLocaleString() || 0} GNF
                            </span>
                        </div>
                        <div className="col-texte-center card m-1">
                            Total Payé:{" "}
                            <span className="text-success fw-bold">
                                {totalPaye?.toLocaleString() || 0} GNF
                            </span>
                        </div>
                        <div className="col-texte-center card m-1">
                            Total impayé:{" "}
                            <span className="text-danger fw-bold">
                                {totalDette?.toLocaleString() || 0} GNF
                            </span>
                        </div>
                        <button
                            className="btn btn-primary w-auto ms-auto"
                            onClick={printFactures}
                        >
                            <i className="bx bx-printer"></i>
                        </button>
                    </div>

                    <table
                        ref={tableRef}
                        className="table table-hover table-striped table-bordered table-sm"
                    >
                        <thead className="table-primary">
                            <tr>
                                <th>N°FACTURE</th>
                                <th>CLIENT</th>
                                <th>TELEPHONE</th>
                                <th>ADRESSE</th>
                                <th>MONTANT</th>
                                <th>PAYE</th>
                                <th>RESTE</th>
                                <th>VENDEUR</th>
                                <th>DATE</th>
                                <th className="text-end">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody className="plage">
                            {factures.map((fact, ind) => (
                                <tr
                                    key={ind}
                                    className={`tr align-middle ${fact?.suppression ? "bg-danger-subtle" : ""
                                        }`}
                                >
                                    <td>{fact.numero}</td>
                                    <td className="critere">{fact.client}</td>
                                    <td>{fact.telephone}</td>
                                    <td>{fact.adresse}</td>
                                    <td>{(+fact.montant).toLocaleString()}</td>
                                    <td>{(+fact.paye).toLocaleString()}</td>
                                    <td>{(+fact.reste).toLocaleString()}</td>
                                    <td>{(fact.vendeur || "").toUpperCase()}</td>
                                    <td>{fact.created_at}</td>
                                    <td className="text-end">
                                        <ContextMenuFacture facture={fact} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    ) : (
        <div className="row p-2 bg-danger-subtle text-danger justify-content-center fs-3">
            Aucune facture impayées!
        </div>
    );
};

export default FactureNonPayees;
